import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
export class HeaderComponent extends Vue {

    @Prop()
    public title: any;

}